export { columns as vendorArticlesColumns } from "./table-config";
export { VendorArticlesMenu } from "./vendor-articles-menu";
